import { baseResourceOptions } from './utils';
import { BTResource } from 'src/models/Sidekick/SidekickModuleSpec';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

const sidekickBTreeResourcesResource = createCollectionResource<BTResource>({
  name: 'sidekickBTreeResources',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/bt-resources',
  type: BTResource,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickBTreeResourcesResource;
